<ng-container *ngIf="!isExistingUser; else matchingProgress">
  <flows-intake-independent-resend></flows-intake-independent-resend>
</ng-container>
<ng-template #matchingProgress>
  <flows-intake-embedded-resend></flows-intake-embedded-resend>
</ng-template>
